import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Box, Typography } from '@material-ui/core';
import { PluginManager, ModuleTypeEnum } from '@kailona/core';
import { DashboardWidget } from '@kailona/ui';
import { withModal } from '../context/ModalContext';
import Timeline from './Timeline/Timeline';

var Dashboard = /*#__PURE__*/function (_Component) {
  _inherits(Dashboard, _Component);

  var _super = _createSuper(Dashboard);

  function Dashboard() {
    var _this;

    _classCallCheck(this, Dashboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onRedirectWidgetClick", function (path) {
      _this.props.history.push(path);
    });

    return _this;
  }

  _createClass(Dashboard, [{
    key: "getWidgets",
    value: function getWidgets() {
      var _this2 = this;

      var widgets = []; // Get widget modules from plugins

      PluginManager.plugins.forEach(function (plugin) {
        var path = plugin.path,
            modules = plugin.modules;
        var widgetModule = modules[ModuleTypeEnum.WidgetModule];

        if (!widgetModule) {
          return;
        }

        widgets.push(_objectSpread({
          path: path
        }, widgetModule));
      }); // Sort by priority (high priority comes first)

      widgets.sort(function (i1, i2) {
        return i1.priority < i2.priority ? 1 : -1;
      });
      return widgets.map(function (widget, index) {
        var WidgetComponent = widget.Component,
            name = widget.name,
            icon = widget.icon,
            path = widget.path; // Render a widget with custom component

        if (WidgetComponent) {
          return /*#__PURE__*/React.createElement(Grid, {
            key: index,
            item: true
          }, /*#__PURE__*/React.createElement(DashboardWidget, null, /*#__PURE__*/React.createElement(WidgetComponent, {
            key: index
          })));
        } // Render a widget with name and icon redirecting user to a page


        return /*#__PURE__*/React.createElement(Grid, {
          key: index,
          item: true
        }, /*#__PURE__*/React.createElement(DashboardWidget, {
          onClick: function onClick() {
            return _this2.onRedirectWidgetClick(path);
          },
          icon: icon,
          name: name
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var widgets = this.getWidgets();
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "column",
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Timeline, null)), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Box, {
        mt: 2,
        ml: 4
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3",
        color: "primary"
      }, t('ehr', 'Shortcuts')), /*#__PURE__*/React.createElement(Box, {
        mt: 1,
        pl: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(DashboardWidget, {
        onClick: function onClick() {
          return _this3.props.toggleRequestDataModal(true);
        },
        icon: "ArchiveOutlined",
        name: t('ehr', 'Request Data from Provider')
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(DashboardWidget, {
        onClick: function onClick() {
          return _this3.props.toggleImportDataModal(true);
        },
        icon: "CloudUploadOutlined",
        name: t('ehr', 'Import Data')
      })), widgets)))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Dashboard;
}(Component);

var _default = withRouter(withModal(Dashboard));

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Dashboard, "Dashboard", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/Dashboard.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/Dashboard.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();